export const Mark = ({ size = 34, inverse = false }) => (
  <svg aria-hidden="true" width={size} height={size} viewBox="0 0 34 34" style={{ flex: "none" }}>
    <rect width="34" height="34" rx="8" fill={inverse ? "#ffffff" : "#C8102E"} />
    <g transform="translate(4 4) scale(0.2167)">
      <path d="M4 60 H12 C30 60 40 34 60 34 C80 34 90 60 108 60 H116" fill="none" stroke={inverse ? "#C8102E" : "#ffffff"}
        strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 60 C30 60 40 86 60 86 C80 86 90 60 108 60" fill="none" stroke={inverse ? "#C8102E" : "#ffffff"}
        strokeWidth="10" strokeLinecap="round" />
      <circle cx="60" cy="60" r="13" fill={inverse ? "#C8102E" : "#ffffff"} />
      <circle cx="55" cy="55" r="4" fill={inverse ? "#ffffff" : "#C8102E"} />
    </g>
  </svg>
);

export const Wordmark = ({ size = 22, dark = false }) => (
  <span className="head" style={{ fontWeight: 700, fontSize: size, letterSpacing: "-0.01em", color: dark ? "#fff" : "#14232a" }}>
    <span style={{ fontWeight: 500 }}>Reimagine</span>
    <span style={{ color: dark ? "#fff" : "#C8102E", fontWeight: 800 }}>Cork</span>
  </span>
);

export const Logo = ({ size = 34, text = 22, dark = false }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
    <Mark size={size} />
    <Wordmark size={text} dark={dark} />
  </span>
);
